/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle-events[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:2.3rem}.circle-events__wall[_ngcontent-%COMP%]{max-height:500px;overflow:auto}"];
export { styles as styles };
